<template>
    <div class="item-tour" v-if="show">
        <ul>
            <li>
                <div class="has-icon add-icon add-tour d-flex justify-content-between">
                    <div>
                        <p>{{dayDetail.descriptionTitle}}</p>
                    </div>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import {isDateInPeriod, isSameDate} from '../../../../utils/helper'
import {toDateFromServer} from '../../../../utils/formatter'

export default {
  name: 'ItemMinitourDay',
  props: {
    day: {
      type: Date,
      default: new Date()
    }
  },
  computed: {
    show () {
      const start = toDateFromServer(this.tour.date.date)
      const end = this.$moment(start).add(this.days - 1, 'days').toDate()
      return isDateInPeriod(this.day, {start, end})
    },
    detail () {
      return this.tour.anagrafica ? this.tour.anagrafica.detailResponse.detail : this.tour.detailResponses[0].detail
    },
    name () {
      return this.detail.name
    },
    days () {
      return this.detail.days
    },
    tour () {
      return this.getTour()
    },
    dayDetail () {
      return this.detail.dayByDay.find((item, index) => {
        const start = toDateFromServer(this.tour.date.date)
        const current = this.$moment(start).add(index, 'days').toDate()
        return isSameDate(current, this.day)
      })
    }
  },
  methods: {
    ...mapGetters(['getTour'])
  }
}
</script>



// WEBPACK FOOTER //
// src/front/components/widgets/common/itinerario/ItemMinitourDay.vue